import React from 'react';
import { Typography } from '@mui/material';

import CheckIcon from '@/components/shared/icons/check-icon';
import ConvocadoIcon from '@/components/shared/icons/convocado-icon';
import SancionadosIcon from '@/components/shared/icons/sancionados-icon';
import AvailableStatusIcon from '@/components/shared/icons/status-icons/available-status-icon';
import DudaLeveStatusIcon from '@/components/shared/icons/status-icons/duda-leve-status-icon';
import DudaStatusIcon from '@/components/shared/icons/status-icons/duda-status-icon';
import ExtradeportivoIcon from '@/components/shared/icons/status-icons/extradeportivo-icon';
import InjuredStatusIcon from '@/components/shared/icons/status-icons/injured-status-icon';

import { PLAYER_STATUS } from '@/constants/player-constants';
import CustomTooltip from '../components/tooltip/CustomTooltip';

const STATUS_INFO = {
    [PLAYER_STATUS.OK]: {
        label: () => 'Disponible para competir',
        icon: (width, height) => <AvailableStatusIcon iconWidth={width} iconHeight={height} />,
    },
    [PLAYER_STATUS.SANCTIONED]: {
        label: () => 'Sancionado, no disponible para competir',
        icon: (width, height) => <SancionadosIcon iconWidth={width} iconHeight={height} />,
    },
    [PLAYER_STATUS.DOUBTFUL]: {
        label: (level) => {
            switch (level) {
                case 1:
                    return 'Duda leve, creemos que llega a la siguiente jornada';
                case 2:
                    return 'Duda, es probable que no llegue a la siguiente jornada';
                default:
                    return '';
            }
        },
        icon: (width, height, level) =>
            level === 1 ? (
                <DudaLeveStatusIcon iconWidth={width} iconHeight={height} />
            ) : (
                <DudaStatusIcon iconWidth={width} iconHeight={height} />
            ),
    },
    [PLAYER_STATUS.INJURED]: {
        label: (level) => {
            switch (level) {
                case 1:
                    return 'Lesionado de duración baja o media, máximo 3 meses';
                case 2:
                    return 'Lesionado de larga duración, mínimo 3 meses';
                case 3:
                    return 'Baja por razones extradeportivas';
                default:
                    return '';
            }
        },
        icon: (width, height, level) => {
            if (level === 1) {
                return <InjuredStatusIcon iconWidth={width} iconHeight={height} color="#e11d48" />;
            } else if (level === 2) {
                return <InjuredStatusIcon iconWidth={width} iconHeight={height} color="#22272F" />;
            } else if (level === 3) {
                return <ExtradeportivoIcon iconWidth={width} iconHeight={height} />;
            }
            return null;
        },
    },
    [PLAYER_STATUS.CONVOCADO]: {
        label: () => 'Convocado con su selección',
        icon: (width, height) => <ConvocadoIcon width={width} height={height} />,
    },
    [PLAYER_STATUS.NO_CONVOCADO]: {
        label: () => 'Desconvocado de su selección',
        icon: (width, height) => <CheckIcon width={width} height={height} />,
    },
};

const useStatusIcon = ({
    status,
    statusLevel,
    width = 20,
    height = 20,
    skipIfNotOk = false,
    includeLabel = false,
}) => {
    status = status ? status : PLAYER_STATUS.OK;
    if (skipIfNotOk && (status === PLAYER_STATUS.OK || !status)) {
        return null;
    }

    const statusEntry = STATUS_INFO[status];

    if (!statusEntry) return null;

    const Icon = statusEntry.icon(width, height, statusLevel);
    const label = statusEntry.label(statusLevel);

    return (
        <CustomTooltip title={label} arrow>
            <Typography component="span" sx={{ lineHeight: 0 }}>
                {Icon}
                {includeLabel && (
                    <Typography component={'span'} sx={{ fontSize: '14px', marginLeft: 0.5 }}>
                        {label}
                    </Typography>
                )}
            </Typography>
        </CustomTooltip>
    );
};

export default useStatusIcon;
